<template>
  <div class="chart-container">
    <canvas :id="chartid"></canvas>
  </div>
</template>
<script>
import vue from "vue";
import Chart from "chart.js/dist/Chart";
import { roundPrice } from "@/utils";

export default vue.extend({
  template: "#chart-template",
  components: {},
  props: {
    v: { type: Object },
    mode: { type: String },
  },
  computed: {
    chartid() {
      return "chart-" + this.mode + "" + this.v.symbol.toLowerCase();
    },
    numbers() {
      return [this.v.predictionClose10Day, this.v.prediction1Month, this.v.prediction2Month, this.v.prediction3Month]
    },
    min() {     
      return Math.min(...this.numbers)
    },
    max() {     
      return Math.max(...this.numbers)
    },
    scale() {
      return  (this.max - this.min) / 10.0;
    },
    maxScale() {     
      return this.max + this.scale
    },
    minScale() {     
      return this.min - this.scale
    },
  },
  async mounted() {
    var options = {
      tooltips: {
        // Disable the on-canvas tooltip
        enabled: false,

        custom: function (tooltipModel) {
          // Tooltip Element
          var tooltipEl = document.getElementById("chartjs-tooltip");

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<table></table>";
            tooltipEl.style.backgroundColor = "#FFFFFF";
            tooltipEl.style.borderColor = "#000000";
            tooltipEl.style.borderRadius = "4px";
            tooltipEl.style.borderWidth = "thin";
            tooltipEl.style.borderStyle = "solid";
            document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set caret Position
          tooltipEl.classList.remove("above", "below", "no-transform");
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add("no-transform");
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            var bodyLines = tooltipModel.body.map(getBody);

            var innerHtml = "<tbody>";

            bodyLines.forEach(function (body, i) {
              body = body.map(function (d) {
                return d.replace(":", "").trim();
              });

              var colors = tooltipModel.labelColors[i];
              var style = "background:" + colors.backgroundColor;
              // var nBody = body.replace(":". "");
              style += "; border-color:" + colors.borderColor;
              style += "; border-width: 2px";
              var span = '<span style="' + style + '"></span>';
              innerHtml += "<tr><td>" + span + "$" + body + "</td></tr>";
            });
            innerHtml += "</tbody>";

            var tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;
          }

          // `this` will be the overall tooltip
          var position = this._chart.canvas.getBoundingClientRect();

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = "absolute";
          tooltipEl.style.left =
            position.left + window.pageXOffset + tooltipModel.caretX + "px";
          tooltipEl.style.top =
            position.top + window.pageYOffset + tooltipModel.caretY + "px";
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
          tooltipEl.style.padding =
            tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
          tooltipEl.style.pointerEvents = "none";
        },
      },

      maintainAspectRatio: false,
      fill: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            stacked: true,
            gridLines: {
              drawBorder: false,
              display: false,
            },
            ticks: {
              display: false,
              min: this.minScale,
              max: this.maxScale                               
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              drawBorder: false,
              display: false,
            },
          },
        ],
      },
    };

    //chart overiddes
    Chart.defaults.global.defaultFontSize = 9;
    Chart.defaults.global.defaultFontColor = "#000";

    Chart.Line(this.chartid, {
      options: options,
      data: {
        labels: ["10 days", "1 Month", "2 Month", "3 Month"],
        datasets: [
          {
            fill: false,
            borderColor: "rgba(255,99,132,1)",
            borderWidth: 2,
            data: [
              roundPrice(this.v.predictionClose10Day),
              roundPrice(this.v.prediction1Month),
              roundPrice(this.v.prediction2Month),
              roundPrice(this.v.prediction3Month),
            ],
            tension: 0.01,
            borderCapStyle: "round",
            borderJoinStyle: "round",
            pointBorderColor: "#fff",
            pointBackgroundColor: "#6cbd8d",
            pointBorderWidth: 2,
            pointRadius: 6,
          },
        ],
      },
    });
  },
});
</script>

<style>
</style>